module.exports = __webpack_public_path__ + "img/h&s1.ce2fc7e1.jpeg";